module.exports = __webpack_public_path__ + "img/no.8331157c.svg";